export default __webpack_public_path__ + "static/media/saims.5c0ed551.jpeg";